'use client';

import { useEffect, useRef } from 'react';

const WIDGET_SRC = 'https://widget.trustbedrijf.nl/w/bd543b68-fcfe-45d9-89cd-e12595b69561.js';

export function TrustbedrijfWidget() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || el.querySelector('script')) return;
    const s = document.createElement('script');
    s.src = WIDGET_SRC;
    s.async = true;
    el.appendChild(s);
  }, []);

  return <div ref={ref} className="flex justify-center mt-4" />;
}
